export function useQuickShopStatus() {
  return useState<'uninitialized' | 'hidden' | 'visible'>('quickShopStatus', () => 'uninitialized')
}
